/* eslint-disable */
export const GreetingsUser = (userName) => {
  return `Olá, ${userName}`;
};
